import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-quote-warning-modal',
    templateUrl: './quote-warning-modal.component.html',
    styleUrls: ['./quote-warning-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class QuoteWarningModalComponent {
  @Input() modalId = 'quote-warning-modal';
  @Output() confirmation = new EventEmitter();
  @ViewChild(ModalComponent) modal: ModalComponent;

  constructor() {}

  show() {
    this.modal.show();

    setTimeout(() => {
      this.modal.focusTitle();
    }, 500);
  }

  close() {
    this.modal.close();
  }

  confirm() {
    this.confirmation.emit(true);
    this.close();
  }

  reject() {
    this.confirmation.emit(false);
    this.close();
  }
}
